import {Enum} from 'enumify';

export default class SideType extends Enum {}

SideType.initEnum({
  LEFT: {
    title: 'Left',
  },
  RIGHT: {
    title: 'Right',
  },
});



// WEBPACK FOOTER //
// ./src/constants/SideType.js